$ = require 'jquery'
GoogleApi = require 'app/scripts/lib/google-api'

# Load the js api immediately
$.getScript('https://apis.google.com/js/api.js', -> GoogleApi.loadedAuth())
